module.exports = __webpack_public_path__ + "static/media/gsb-iconFree.d28f8cde.svg";